import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-material-purchase',
  templateUrl: './material-purchase.component.html',
  styleUrls: ['./material-purchase.component.css']
})
export class MaterialPurchaseComponent implements OnInit {

  data: any;
  cid: any
  form: any | FormGroup
  viewform: any | FormGroup
  modelSubtitle = false
  quantityArr: any = []
  checked = false

  name = ""
  version = ""
  isActive = false
  i: any;
  deleteId: any = "";
  products: any = [];
  vendor: any = [];
  branch: any = [];
  materials: any = [];
  make: any = ''
  modal: any = ''
  slNo: any = ''
  expiryDate: any = ''
  invoiceDate: any = '';
  controls: any = []
  materialdata: any = [];
  viewProd: any = []
  viewData: any = []
  addClassType = ""
  viewstatus: any = [];
  uomData: any = [];
  id: any;

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage: number = 10;
  tableSize: number = 10;
  first: number = 0;
  isLoading: any = false

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  }

  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {

    let href: any = window.location.href;
    let messages = href.split('/')
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1])
    this.actionControls = action


    this.cid = sessionStorage.getItem('cid')
    this.getAllMaterial(this.pageNumber, this.recordsPerPage)
    this.getAllUomMaster()
    this.form = this.fb.group({
      branchId: [''],
      branchName: ['', [Validators.required]],
      invoiceNo: ['', [Validators.required]],
      vendorName: ['', [Validators.required]],
      productName: [''],
      infoObj: this.fb.array([]),
      quantity: [''],
      invoiceDate: ['', [Validators.required]]
    })

    this.viewform = this.fb.group({
      branchName: [''],
      invoiceNo: [''],
      vendorName: [''],
      productName: [''],
      // infoObj:this.fb.array([]),
      // quantity:[''],
      invoiceDate: ['']
    })

    this.generic_service.getAllProducts().subscribe(
      (res: any) => {
        console.log(res)
        this.products = res.response
      }
    )

    this.generic_service.getAllVendor().subscribe(
      (res: any) => {
        this.vendor = res.response
      }
    )

    this.generic_service.getBranch().subscribe(
      (res: any) => {
        this.branch = res.response
      }
    )
  }

  get infoArr() {
    return this.form.get('infoObj') as FormArray;
  }

  InfoObject() {
    return this.fb.group({
      "make": [''],
      "modal": [''],
      "slNo": [''],
      "expiryDate": [0],
    })
  }

  addInfoObject() {
    this.infoArr.clear()
    let q = Number(this.form.get('quantity').value)
    for (let i = 0; q > i; i++) {
      this.infoArr.push(this.InfoObject())
    }
  }

  removeInfoObject(index: number) {
    this.infoArr.removeAt(index)
  }

  addMaterial() {

    let isValid: any = true;
    for (let list of this.prod) {
      if (list.productName == "" || list.uomName == "") {
        isValid = false
      }
    }

    if (!this.form.valid || !isValid) {
      this.toastr.error('All fields are mandatory')
      return
    }

    for (let i = 0; i < this.prod.length; i++) {
      if (this.prod[i].quantity == 0) {
        for (let j = 0; j < this.prod[i].infoObj.length; j++) {
          this.prod[i].infoObj[j].expiryDate = new Date(this.prod[i].infoObj[j].expiryDate).getTime()
        }


      } else {
        this.prod[i].infoObj = []
      }

      if (this.prod[i].warranty) {
        this.prod[i].warrantyInfo.expirationDate = new Date(this.prod[i].warrantyInfo.expirationDate).getTime()
        this.prod[i].warrantyInfo.purchaseDate = new Date(this.prod[i].warrantyInfo.purchaseDate).getTime()

      }
      delete this.prod[i].uomList
      delete this.prod[i].productList
      delete this.prod[i].version

    }

    for (let i = 0; i < this.branch.length; i++) {
      if (this.branch[i].name == this.form.get('branchName').value) {
        this.form.patchValue({
          branchId: this.branch[i].branchMasterId
        })
      }
    }

    let body1 = {
      "version": 1,
      "isActive": true,
      "description": "",
      "branchId": Number(this.form.get('branchId').value),
      "branchName": String(this.form.get('branchName').value),
      "invoiceNo": String(this.form.get('invoiceNo').value),
      "vendorName": String(this.form.get('vendorName').value),
      "productList": this.prod,
      "status": [
        {
          "userId": Number(sessionStorage.getItem("userId")),
          "purchaseTransferStatus": "ENTER",
          "updatedDate": new Date().getTime()
        }
      ],
      "latestStatus": "ENTER",
      "tranType": "INVOICE",
      "cid": Number(this.cid),
      "invoiceDate": new Date(this.form.get('invoiceDate').value).getTime()
    }

    console.log(body1)
    this.generic_service.addMaterial(body1).subscribe(
      (response: any) => {
        console.log(response)
        this.getAllMaterial(this.pageNumber, this.recordsPerPage)
        this.toastr.success(response.message);
        this.cancelModel()
        this.form.reset()
        this.prod = []

      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.errors[0].description);

      },
    )
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    this.form.reset()
    this.prod = []
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.getAllMaterial(this.pageNumber, this.recordsPerPage)
  }


  getAllMaterial(pageNumber: any, recordsPerPage: any) {
    this.isLoading = true

    this.generic_service.getAllMaterial(pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        this.materials = response.response.materialPurchaseList;
        this.totalRecords = response.response.totalRecords;
        console.log(response)
        this.isLoading = false

      }
    )
  }

  // getMaterialById(id:any){
  //   this.generic_service.getMaterialById(id).subscribe(
  //     (response:any)=>{
  //       this.materialdata = response.response;
  //       console.log(response)
  //     }
  //   )
  // }

  getMaterialById(id: any) {
    this.id = id;
    this.generic_service.getMaterialById(id).subscribe(
      (response: any) => {
        console.log(response)
        this.viewData = []
        this.viewData.push(response.response);
        this.viewProd = response.response.productList
        this.viewstatus = []
        this.viewstatus = response.response.status
      },
      (error) => {
        console.log(error)
        this.viewData = []
        this.viewProd = []

      }
    )
  }

  getAllProduct() {
    // this.generic_service.getProduct().subscribe(
    //   (res:any)=>{
    //     console.log(res)
    //     this.products = res.response
    //   }
    // )
  }

  getAllVendor() {
    // this.generic_service.getVendor().subscribe(
    //   (res:any)=>{
    //     this.vendor = res.response
    //   }
    // )
  }

  getAllBranch() {
    this.generic_service.getBranch().subscribe(
      (res: any) => {
        this.branch = res.response
      }
    )
  }

  getAllUomMaster() {
    this.generic_service.getAllUomMaster().subscribe(
      (res: any) => {
        console.log(res)
        this.uomData = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  uomChange(index: any) {
    let uomList = this.prod[index].uomList;
    for (var i = 0; uomList.length > i; i++) {
      if (uomList[i].uomName == this.prod[index].uomName) {
        this.prod[index].uomId = uomList[i].uomId || uomList[i].uomMasterId;
        console.log(uomList[i])
        console.log(this.prod)
      }
    }
  }

  productNameSelect(index: any) {
    for (let i = 0; i < this.products.length; i++) {
      if (this.products[i].name == this.prod[index].productName) {
        console.log(this.products[i])
        this.prod[index].uomList = this.products[i].supportedUOM
      }
    }

    console.log(this.prod)
  }

  open() {
    this.modelSubtitle = true;
  }
  close() {
    this.modelSubtitle = false;
    this.name = ""
    this.version = ""
    this.isActive = false

  }

  quantity() {
    let body = {
      "make": "",
      "modal": "",
      "slNo": "",
      "expiryDate": ""
    }

    let quantity = Number(this.form.get('quantity').value)
    let arr = []
    if (quantity != 0 || quantity != null) {
      for (let i = 0; quantity > i; i++) {
        arr.push(body)
      }
      this.quantityArr = arr
    }
  }

  prod: any = []

  addP() {
    this.prod.push(
      {
        "productName": String(this.form.get('productName').value),
        "infoObj": [
          {
            "make": "",
            "modal": "",
            "slNo": 0,
            "expiryDate": 0,
            "url": "",
            "lat": "",
            "lon": ""
          }
        ],
        "quantity": 0,
        "uomId": 0,
        "uomName": "",
        "uomList": [],
        "productList": [],
        "version": ""
      }
    )
  }

  addi(i: any) {
    this.prod[i].infoObj.push(
      {
        "make": "",
        "modal": "",
        "slNo": 0,
        "expiryDate": 0,
        "url": "string",
        "lat": "string",
        "lon": "string"
      }
    )
  }

  deletei(i: any) {
    this.prod[i].infoObj.pop()
  }

  removeProd(i: any) {
    console.log(i)
    this.prod.splice(i, 1)
    console.log(this.prod)
  }

  removeinfoObj(i: any, j: any) {
    console.log(i)
    console.log(j)
    this.prod[i].infoObj.splice(j, 1)
    console.log(this.prod)
  }

  clear() {
    this.prod = []
    this.form.reset()
    console.log(this.prod)
  }

  getProductVersion(product: any, index: any) {
    for (var i = 0; i < this.products.length; i++) {
      if (this.products[i].name == product) {
        return this.products[i].version
      }
    }
  }


  approvePurchase() {

    console.log(this.viewData)
    let res: any = [];
    res = this.viewData[0];

    for (let i = 0; i < res.productList.length; i++) {
      res.productList[i].approveQty = res.productList[i].quantity
      delete res.productList[i].quantity
      delete res.productList[i].approvedQty
      delete res.productList[i].uomName
      delete res.productList[i].uomId

      console.log(res)
    }
    let body = {
      "id": Number(this.viewData[0].materialPurchaseId),
      "purchaseStatusDTO": {
        "userId": Number(sessionStorage.getItem("userId")),
        "purchaseTransferStatus": "APPROVED",
        "updatedDate": new Date().getTime()
      },
      "productSerialNoList": res.productList
    }
    console.log(body)

    this.generic_service.updatePurchaseStatus(body).subscribe(
      (response: any) => {
        console.log(response)
        this.toastr.success(response.message);

        this.cancelModel()
        this.getMaterialById(this.id)
      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description);

      },
    )
  }

  rejectPurchase() {

    console.log(this.viewData)
    let res: any = [];
    res = this.viewData[0];

    for (let i = 0; i < res.productList.length; i++) {
      res.productList[i].approveQty = res.productList[i].quantity
      delete res.productList[i].quantity
      delete res.productList[i].approvedQty
      delete res.productList[i].uomId

      console.log(res)
    }
    let body = {
      "id": Number(this.viewData[0].materialPurchaseId),
      "purchaseStatusDTO": {
        "userId": String(sessionStorage.getItem("userId")),
        "purchaseTransferStatus": "REJECTED",
        "updatedDate": new Date().getTime()
      },
      "productSerialNoList": res.productList
    }
    console.log(body)

    this.generic_service.updatePurchaseStatus(body).subscribe(
      (response: any) => {
        console.log(response)
        this.toastr.success(response.message);
        this.cancelModel()
        this.getMaterialById(this.id)
      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description);

      },
    )
  }


  selectProductName(product: any, index: any, productName: any, supportedUOM: any, version: any) {
    this.prod[index].productName = productName
    this.prod[index].uomList = supportedUOM
    this.prod[index].version = version
    console.log(product)
    this.prod[index].warranty = product.warranty
    this.prod[index].warrantyInfo = product.warrantyInfo

    this.prod[index].productList = []

  }

  getAllByWildSearchWithoutPagination(index: any) {
    this.prod[index].uomList = []
    if (this.prod[index].productName == "") {
      return
    }

    this.generic_service.getAllByWildSearchWithoutPagination(this.prod[index].productName).subscribe(
      (res: any) => {
        console.log(res)
        this.prod[index].productList = res.response
      },
      (err: any) => {
        this.prod[index].productList = []
      }
    )
  }


  searchKey: any = ""

  getMaterialPurchaseByWildSearch(pageNumber: any, recordsPerPage: any) {
    console.log(this.searchKey)
    if (this.searchKey != "") {
      this.isLoading = true

      this.generic_service.getMaterialPurchaseByWildSearch(this.searchKey, pageNumber, recordsPerPage).subscribe(
        (response: any) => {
          console.log(response);
          this.materials = response.response.materialPurchaseList;
          this.totalRecords = response.response.totalRecords;
          this.isLoading = false

        },
        (err: any) => {
          console.log(err)
        }
      )
    } else {
      this.getAllMaterial(this.pageNumber, this.recordsPerPage)
    }
  }

  refreshSearch() {
    this.searchKey = ""
    this.getAllMaterial(this.pageNumber, this.recordsPerPage)
  }


  refreshAll() {
    this.pageNumber = 0
    this.searchKey = ""
    this.getAllMaterial(this.pageNumber, this.recordsPerPage)
  }


}